export const BASE_URL = "https://api.thepaygram.com/admin/v1";
